import React from 'react';
import './footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className='container-footer'>
      <div className='container-fluid'>
        <div className='row first-row'>
          <div className='col-md-9 col-12'>
            <div className='footer_logo_numbers'>
              <div className='footer_logo'>
                <img src='https://cdn.hidalgo.gob.mx/gobierno/images/logos/logo_gob.png' alt="Gobierno"/>
              </div>
              <div className='footer_numbers'>
                <div>
                  <p>911</p>
                  <p>Emergencia</p>
                </div>
                <div>
                  <p>089</p>
                  <p>Denuncia Anónima</p>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-3 col-12'>
            <div className='footer_contacto'>
              <h6><a href='https://gobierno.hidalgo.gob.mx/AvisoPrivacidad' target="_new">Aviso de privacidad</a></h6>
              <h6>Contacto:</h6>
              <div dangerouslySetInnerHTML={{ __html: window._my_contacto }}/>
            </div>
          </div>
        </div>
        <hr className='hr-gob' />
        <div className='row second-row'>
          <div className='col-sm-9 col-12'>
            <p>Copyrights © {currentYear} Todos los derechos reservados por Hidalgo de la Transformación</p>
          </div>
          <div className='col-sm-3 col-12'>
            <div className='footer_sociales'>
              {
                window._my_gob_face ?
                  <a href={window._my_gob_face} target="_new"><i className="fa-brands fa-facebook-f"></i></a>
                :
                  null
              }
              {
                window._my_gob_x ?
                  <a href={window._my_gob_x} target="_new"><i className="fa-brands fa-twitter"></i></a>
                :
                  null
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer